import "./ChooseBank.scss";
import React, { useState } from "react";
import DynaInput from "../../../UI/DynaInput/DynaInput";
import RLookUpModal from "../RLookUpModal/RLookUpModal";
import {
  parseToEnRemoveComma,
  formatToPersianAddComma,
} from "../../../../utils/CommaSeparator";

const ChooseBank = ({
  sendData,
  setSendData,
  initialData,
  componentData,
  setComponentData,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="choose_bank_box">
      <button
        className="counterFactorBtn__"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        {sendData?.currentSelectedBankAccountName}
      </button>
      <DynaInput
        label={"مبلغ پرداختی"}
        placeholder={"مبلغ را وارد کنید"}
        typeMode={"input"}
        type={"text"}
        className={"solid-login-type inputClass__"}
        value={formatToPersianAddComma(sendData?.paidPrice)}
        onChange={(e) => {
           // Remove any non-numeric characters
           const enteredValue = parseToEnRemoveComma(e.target.value);
           const numericValue = enteredValue.replace(/[^0-9]/g, "");
           setSendData({ paidPrice: numericValue });
           setComponentData({ reload: Math.random() });
        }}
      />
      <>
        {isOpen && (
          <RLookUpModal
            id={initialData?.bankRLookUpId}
            callBackDataHandler={(incomingData) => {
              // console.log(incomingData);
              setSendData({
                // bank: { id: incomingData.na_15, name: incomingData.na_166 },
                bankId: incomingData.na_15,
                currentSelectedBankAccountName: incomingData.na_166,
              });
            }}
            modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}
          />
        )}
      </>
    </div>
  );
};

export default ChooseBank;
